import { LitElement } from "lit";
import { unsafeStatic, html } from "lit/static-html.js";
import { i18n } from "@lingui/core";

var supportedLocales = ["en", "nb", "fi", "da", "sv"];
var defaultLocale = "en";
var detectByBrand = () => {
  var _a;
  let value;
  switch ((_a = process == null ? void 0 : process.env) == null ? void 0 : _a.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname == null ? void 0 : hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale;
  }
};
var getSupportedLocale = (usedLocale) => {
  return supportedLocales.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost();
};
function detectLocale() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand();
    return getSupportedLocale(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost();
    if (!supportedLocales.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale(hostLocale);
    }
    return getSupportedLocale(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e) {
    console.warn("could not detect locale, falling back to source locale", e);
    return defaultLocale;
  }
}
var getMessages = (locale, enMsg, nbMsg, fiMsg, daMsg, svMsg) => {
  if (locale === "nb") return nbMsg;
  if (locale === "fi") return fiMsg;
  if (locale === "da") return daMsg;
  if (locale === "sv") return svMsg;
  return enMsg;
};
var activateI18n = (enMessages, nbMessages, fiMessages, daMessages, svMessages) => {
  const locale = detectLocale();
  const messages = getMessages(locale, enMessages, nbMessages, fiMessages, daMessages, svMessages);
  i18n.load(locale, messages);
  i18n.activate(locale);
};

var msgs = { "nb": { "icon.title.chair": ["Stol"] }, "en": { "icon.title.chair": ["Chair"] }, "fi": { "icon.title.chair": ["Tuoli"] }, "da": { "icon.title.chair": ["Stol"] }, "sv": { "icon.title.chair": ["Stol"] } };
activateI18n(msgs.en, msgs.nb, msgs.fi, msgs.da, msgs.sv);
var IconChair42 = class extends LitElement {
  render() {
    const title = i18n.t({ message: `Chair`, id: "icon.title.chair", comment: "Title for Chair icon" });
    return html`<svg xmlns="http://www.w3.org/2000/svg"width="42"height="28"fill="none"viewBox="0 0 42 28">${unsafeStatic(`<title>${title}</title>`)}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M26.2 24.746H15.8a7.76 7.76 0 0 1-5.513-2.315A7.95 7.95 0 0 1 8 16.85c0-.698.274-1.367.762-1.861a2.58 2.58 0 0 1 1.838-.77c.69 0 1.35.276 1.838.77.488.493.762 1.163.762 1.86 0 .699.275 1.368.762 1.86a2.58 2.58 0 0 0 1.838.772h10.4c.69 0 1.35-.278 1.838-.771a2.65 2.65 0 0 0 .762-1.86c0-.698.274-1.367.761-1.861a2.58 2.58 0 0 1 1.839-.77c.69 0 1.35.276 1.839.77.487.493.761 1.163.761 1.86a7.95 7.95 0 0 1-2.287 5.58 7.76 7.76 0 0 1-5.513 2.316ZM11.467 26.5l1.197-2.422m17.87 2.422-1.198-2.422"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m30.18 14.528-.925-10.053a3.52 3.52 0 0 0-1.17-2.13 3.44 3.44 0 0 0-2.257-.845h-9.654c-.828 0-1.628.3-2.257.846a3.52 3.52 0 0 0-1.169 2.13l-.924 10.052"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M25.333 15.974v-1.755c0-.465-.182-.911-.507-1.24a1.72 1.72 0 0 0-1.226-.514h-5.2c-.46 0-.9.185-1.226.514a1.77 1.77 0 0 0-.508 1.24v1.755"></path></svg>`;
  }
};
if (!customElements.get("fp-icon-chair-42")) {
  customElements.define("fp-icon-chair-42", IconChair42);
}
export {
  IconChair42
};
